// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__TFlLg","rootCenter":"LoadMoreObserver_rootCenter__frHCo","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__14CvX"};